import axios from 'axios';
import { errorInterceptor } from './errorInterceptor';

export const baseUrl =
    `${window.location.origin.indexOf('localhost') < 0
        ? window.location.origin
        : 'https://dev.alexwb.com.br'
    }/v1`;

const api = axios.create({
    baseURL: baseUrl,
});

// Request interceptor - add auth token
api.interceptors.request.use((config) => {
    let token = localStorage.getItem('user_token') || {};

    try {
        token = JSON.parse(token);
    } catch (error) {        
        token = {};
    }

    const currentTime = Date.now() / 1000;
    if (
        token.access_token &&
        token.expires_in &&
        token.expires_in > Date.now() / 1000
    ) {
        config.headers = {
            ...config.headers,
            Authorization: 'Bearer ' + token.access_token,
        };        
    }

    return config;
});

// Response interceptor - handle errors consistently
api.interceptors.response.use(
    (response) => {
        return response;
    },
    errorInterceptor,
);

export default api;
